import React from 'react';

export default function CountryFlag({ country }) {
  const src = require(`static/img/countries/${country.toLowerCase()}.png`);
  return (
    <img src={src} style={{ position: 'absolute', top: '5px', right: '5px' }} />
  );
}
